export default __webpack_public_path__ + "static/media/logo_color.9b586c63.png";